export default "__VITE_ASSET__Du5qXLNO__"